import BaseModelAPI from '../BaseModelAPI';

export default class CombineCase extends BaseModelAPI {
    static entity = 'combinecase';
    static entityName = 'combinecase';

    constructor(){

        /*APP_MODEL_DEFINITION*/
        this.id = '';
        this.combineDate = '';
        this.controlCardId = '';
        this.controlCard = {};
        this.partId = '';
        this.part = {};
        this.partNumber4 = '';
        this.partName5 = '';
        this.standarPackagingQty6 = '';
        this.combineCaseDetail = []
        this.isFromUpload = false;
        this.isSavedToBackend = true;
        this.isScanned = '';
        this.uploadValidationMessage = '';
        this.uploadValidationStatus = '';
        /*END_APP_MODEL_DEFINITION*/
    }

    static async resetData(this_, id) {
        return await this_.$http.post(`${this.entityName}/resetdata/${id}`)
            .then(async function(response){
                return response.data;
            })
            .catch(function (error) {
                var stringError = 'Gagal melakukan reset data!';
                if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
                    let errorList = Object.values(error.response.data.errors);
                    const errorObj = errorList.find(() => true);
                    stringError = errorObj[0];
                }
                this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
                throw error;
            });
    }

    static async addAndPrint(this_, id) {
        return await this_.$http.post(`${this.entityName}/addAndPrint/${id}`)
            .then(async function(response){
                return response.data;
            })
            .catch(function (error) {
                var stringError = 'Gagal melakukan addAndPrint!';
                if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
                    let errorList = Object.values(error.response.data.errors);
                    const errorObj = errorList.find(() => true);
                    stringError = errorObj[0];
                }
                this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
                throw error;
            });
    }

    static async scanControlCard(this_, id, qrCode) {
        return await this_.$http.get(`${this.entityName}/ScanControlCard?id=${id}&qrcode=${qrCode}`)
            .then(response => {
                if (response != null && response.data) {
                    return response.data;
                }
                return null;
            }).catch(function (error) {
                var stringError = 'Gagal melakukan scan Control Card!';
                if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
                    let errorList = Object.values(error.response.data.errors);
                    const errorObj = errorList.find(() => true);
                    stringError = errorObj[0];
                }
                this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
                throw error;
            });
    }

    static async printCombineControlCard(this_, id) {
        return await this_.$http.get(`${this.entityName}/printcombinecontrolcard/${id}`)
            .then(async function(response){
                return response.data;
            })
            .catch(function (error) {
                var stringError = 'Gagal melakukan print Combine Control Card!';
                if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
                    let errorList = Object.values(error.response.data.errors);
                    const errorObj = errorList.find(() => true);
                    stringError = errorObj[0];
                }
                this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
                throw error;
            });
    }

}